import { ChangeDetectorRef, Component, HostListener, Input, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { ThemeService } from '../services/themes.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ApiService } from '../services/api.service';
import { SECTION_NAMES, TEMPLATE_NAMES } from '../constants';
import { TitleUpdateService } from '../services/title-update.service';

@Component({
    selector: 'app-whatareweoffering',
    templateUrl: './whatareweoffering.component.html',
    styleUrls: ['./whatareweoffering.component.scss']
})
export class WhatareweofferingComponent implements OnInit {

    @Input() what: any;
    themedata: any;
    fontData: any;
    pageTitle: string;
    whatweare: boolean = false;
    whyTopRatedCardData: any = [];
    headerdata: any = [];
    currentIndex: number = 0;
    length: number = 3;
    currentPartner: number = 0;
    displayedwhatweare: any = [];
    activeDiv: 'show' | 'hide';
    cols: number;

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.setCols(event.target.innerWidth);
    }

    constructor(private titleService: Title,
        private meta: Meta,
        private cookieService: CookieService,
        private themeService: ThemeService,
        private router: Router,
        private spinnerService: NgxSpinnerService,
        private activatedRoute: ActivatedRoute,
        private cdRef: ChangeDetectorRef,
        private dialogRef: MatDialog,
        private apiService: ApiService,
        private titleUpdateService: TitleUpdateService,
    ) {
        this.setCols(window.innerWidth);
        // this.redirectToAdminRoutesAfterLogin();
    }

    ngOnInit(): void {
        this.themeService.theme$.subscribe((response) => {
            this.themedata = response;
        });

        this.themeService.selectedFont$.subscribe((response) => {
            this.fontData = response;
        });

        this.activatedRoute.params.subscribe((params) => {
            this.loadLocalData();
            this.titleUpdateService.setTitleFromRoute();
            this.cdRef.detectChanges();
            this.spinnerService.hide();
        });
    }

    private setCols(width: number) {
        if (width < 600) {
            this.cols = 1;
        } else if (width < 960) {
            this.cols = 2;
        } else if (width < 1025) {
            this.cols = 3;
        } else {
            this.cols = 3;
        }
    }

    getGridCols(): number {
        return this.cols;
    }

    loadLocalData() {
        this.pageTitle = this.titleService.getTitle();

        if (environment.LOAD_LOCAL_DATA) {
            this.apiService.getwhatweare().subscribe((response: any) => {
                this.whyTopRatedCardData = response[`${TEMPLATE_NAMES.HOME}_${SECTION_NAMES.WHY_ENGAGE_WITH_US_CARD}`];
                this.updateSkipmeFlag();
                this.updateDisplayedItems();
            });
        }
    }

    updateSkipmeFlag() {
        this.whyTopRatedCardData = this.whyTopRatedCardData.filter(
            (item: any) => this.pageTitle !== item?.title && this.pageTitle !== item?.name);
    }

    updateDisplayedItems() {
        const totalItems = this.whyTopRatedCardData.length;
        const end = Math.min(this.currentIndex + this.length, totalItems);

        this.displayedwhatweare = this.whyTopRatedCardData.slice(this.currentIndex, end);
    }

    next() {
        if (this.currentIndex + this.length < this.whyTopRatedCardData.length) {
            this.currentIndex += this.length;
        } else {
            this.currentIndex = this.whyTopRatedCardData.length;
        }

        this.updateDisplayedItems();
    }

    pre() {
        if (this.currentIndex > this.length) {
            this.currentIndex -= this.length;
        } else {
            this.currentIndex = 0;
        }

        this.updateDisplayedItems();
    }


}
